"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var viewport_1 = require("reducers/viewport");
var components_1 = require("components");
var ColumnFilter_1 = require("components/ColumnFilter");
var Icon_1 = require("components/Icon");
var sok_ui_1 = require("@caddigital/sok-ui");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var react_router_dom_1 = require("react-router-dom");
var projectActions = require("@caddigital/sok-reducers/lib/actions/projects");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var avatars_1 = require("components/Avatar/avatars");
var Types = require("types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var download_1 = require("utils/download");
var text_1 = require("utils/text");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'name',
    'customerName',
    'projectId',
    'description',
    'projectStatus',
    'projectType'
];
var mobileHeaders = ['name'];
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column)), "data-length": value.length, "data-key": '__' + column }, value));
}
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        projectListStatus: state.projects.projectListStatus,
        projects: state.projects.projects,
        searchString: state.projects.searchString,
        orderByOptions: state.projects.orderByOptions,
        filterOptions: state.projects.filterOptions,
        offset: state.projects.offset,
        limit: state.projects.limit,
        itemsPerPage: state.projects.itemsPerPage,
        showBookmarked: state.projects.showBookmarked,
        showArchived: state.projects.showArchived,
        selectedLanguage: selectedLanguage,
        token: state.auth.current.token,
        selected: state.projects.selected,
        isMobile: (0, viewport_1.isMobile)(state.viewport)
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchDistributionList: function () { return dispatch(projectActions.fetchProjects()); },
    onPaginationChange: function (offset, limit) { return (dispatch(projectActions.setLimit(limit)),
        dispatch(projectActions.setOffset(offset))); },
    sortBy: function (orderBy, order) {
        return dispatch(projectActions.setOrderByOptions(orderBy, order));
    },
    setColumnFilter: function (filter, value) { return (dispatch(projectActions.setFilterOptions(filter, value)),
        dispatch(projectActions.setOffset(0))); },
    bookmark: function (ids) { return dispatch(projectActions.bookmarkProject(ids)); },
    toggleSelection: function (project) {
        return dispatch(projectActions.toggleSelection(project));
    },
    unbookmark: function (ids) {
        return dispatch(projectActions.unbookmarkProject(ids));
    },
    toggleBookmark: function (item, bookmarked) {
        return bookmarked
            ? dispatch(projectActions.bookmarkProject([item.id]))
            : dispatch(projectActions.unbookmarkProject([item.id]));
    },
    downloadProjectFilesZip: function (token) { return function (project) {
        var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
        var uuid = retVal.payload.uuid;
        (0, download_1.downloadFiles)(token, [{ uuid: project.rootFolderIdentifier }], undefined, undefined, function () { return dispatch(ToastActions.removeToast(uuid)); });
    }; },
    clear: function () { return dispatch(projectActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
function getFilteredData(list, searchString, filters, showBookmarked, showArchived) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchString.length > 0 || showArchived || showBookmarked) {
            return list.filter(function (item) {
                return (item.name
                    .toLowerCase()
                    .toString()
                    .includes(searchString.toLowerCase()) ||
                    (item.description || '')
                        .toLowerCase()
                        .toString()
                        .includes(searchString.toLowerCase())) &&
                    (showBookmarked ? item.bookmarked : true) &&
                    (showArchived
                        ? (item.projectStatus && item.projectStatus.name === 'archived') ||
                            (item.projectType && item.projectType.name === 'archived')
                        : true);
            });
        }
        return list;
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters[key];
            switch (key) {
                case 'projectStatus': {
                    var value_1 = item.projectStatus
                        ? (0, translation_1.getLocalization)("".concat(key, "/").concat(item.projectStatus.name))
                        : '-';
                    if (value_1.toLowerCase().indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                case 'projectType': {
                    var value_2 = item.projectType
                        ? (0, translation_1.getLocalization)("".concat(key, "/").concat(item.projectType.name))
                        : '-';
                    if (value_2.toLowerCase().indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                default:
                    var value = item[key];
                    if (!value ||
                        (value &&
                            value
                                .toString()
                                .toLowerCase()
                                .indexOf(searchValue.toLowerCase()) === -1)) {
                        return result;
                    }
            }
        }
        if ((searchString.length > 0
            ? item.name.toLowerCase().includes(searchString.toLowerCase())
            : true) &&
            (showBookmarked ? item.bookmarked : true) &&
            (showArchived
                ? (item.projectStatus && item.projectStatus.name === 'archived') ||
                    (item.projectType && item.projectType.name === 'archived')
                : true)) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.isMobile !== props.isMobile ||
        nextProps.width !== props.width ||
        (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        (0, List_1.shallowDiffers)(nextProps.orderByOptions, props.orderByOptions) ||
        nextProps.showAdminTools !== props.showAdminTools ||
        (0, List_1.shallowDiffers)(props.filterOptions, nextProps.filterOptions);
}));
var Header = enhanceHeader(function (props) {
    return (React.createElement("div", { className: props.className + ' header row', style: props.style },
        props.showAdminTools && React.createElement("div", { className: "row__column narrow icon" }),
        React.createElement("div", { className: "row__column narrow icon" }),
        props.showAdminTools && React.createElement("div", { className: "row__column narrow icon" }),
        props.showAdminTools && React.createElement("div", { className: "row__column narrow icon" }),
        getHeaderColumn(props, 'name', 'name'),
        props.showAdminTools && React.createElement("div", { className: "row__column narrow" }),
        props.showAdminTools && React.createElement("div", { className: "row__column narrow" }),
        getHeaderColumn(props, 'customerName', 'customerName'),
        getHeaderColumn(props, 'projectId', 'projectId'),
        getHeaderColumn(props, 'description', 'description'),
        getHeaderColumn(props, 'projectStatus', 'projectStatus'),
        getHeaderColumn(props, 'projectType', 'projectType')));
});
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", { style: props.style, key: 'no-projects', className: 'no-projects' },
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)((0, avatars_1.getAvatar)(9)) }),
    React.createElement("b", null, (0, translation_1.getLocalization)("pushNotifications/dearSokoproUser")),
    props.searchString.length > 0 ||
        Object.keys(props.filterOptions).length > 0 ? (React.createElement("span", { key: 'search' }, (0, translation_1.getLocalization)("userfront/project/noProjectsWithSearchWord"))) : (React.createElement(React.Fragment, null,
        React.createElement("span", { key: 'no-search-1' }, (0, translation_1.getLocalization)("thereAreNoProjects")),
        React.createElement("span", { key: 'no-search-2' }, (0, translation_1.getLocalization)("pleaseContactHelpdesk")))))); };
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('totalItems', 'setTotalItems', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.clear();
    },
    componentWillReceiveProps: function (nextProps) {
        var items = nextProps.projects;
        if (this.props.showBookmarked !== nextProps.showBookmarked ||
            this.props.showArchived !== nextProps.showArchived ||
            this.props.searchString !== nextProps.searchString ||
            this.props.orderByOptions !== nextProps.orderByOptions ||
            this.props.filterOptions !== nextProps.filterOptions ||
            this.props.offset !== nextProps.offset ||
            this.props.limit !== nextProps.limit ||
            (this.props.projects.length === 0 && nextProps.projects.length) ||
            this.props.projects !== nextProps.projects ||
            (this.props.projectListStatus !== 'FETCHED' &&
                nextProps.projectListStatus === 'FETCHED')) {
            var orderBy_1 = nextProps.orderByOptions.orderBy;
            var order_1 = nextProps.orderByOptions.order === 'asc' ? 1 : -1;
            var data = getFilteredData(items, nextProps.searchString, nextProps.filterOptions, nextProps.showBookmarked, nextProps.showArchived).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'projectStatus':
                        var aps = a.projectStatus ? a.projectStatus.name : '-';
                        var bps = b.projectStatus ? b.projectStatus.name : '-';
                        return aps.localeCompare(bps) * order_1;
                    case 'projectType':
                        var apt = a.projectType ? a.projectType.name : '-';
                        var bpt = b.projectType ? b.projectType.name : '-';
                        return apt.localeCompare(bpt) * order_1;
                    case 'name':
                    case 'customerName':
                    case 'description':
                        return (a[orderBy_1] || '').localeCompare(b[orderBy_1] || '') * order_1;
                    case 'projectId':
                        return ((a[orderBy_1] || 0) - (b[orderBy_1] || 0)) * order_1;
                    default:
                        return 0;
                }
            });
            items = data.slice(Math.max(0, Math.min(data.length, nextProps.offset)), Math.min(nextProps.offset + nextProps.limit, data.length));
            nextProps.setTotalItems(data.length);
            nextProps.setItems(items);
        }
        if (nextProps.isMobile !== this.props.isMobile ||
            nextProps.items !== this.props.items) {
            var columns_1 = nextProps.items.reduce(function (p, item) {
                Object.keys(item).forEach(function (c) {
                    if (!headers.includes(c))
                        return p;
                    var dataKey = '__' + c.replace(/-/g, '');
                    var text = (function (v, c) {
                        if (c === 'projectStatus' || c === 'projectType') {
                            return (0, translation_1.getLocalization)("".concat(c, "/").concat(v));
                        }
                        return v;
                    })((item[c] || '').toString(), c);
                    var length = (0, text_1.calculateStringLength)(text);
                    var prevValue = p[dataKey];
                    if (prevValue && prevValue.length < length) {
                        prevValue.text = text;
                        prevValue.length = length;
                    }
                    else if (!prevValue) {
                        p[dataKey] = {
                            text: text,
                            length: length
                        };
                    }
                });
                return p;
            }, {});
            var shownHeaders = headers;
            shownHeaders.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("userFront/projectsTab/columns/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('ProjectListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'ProjectListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            var contentWidth_1 = (nextProps.showAdminTools ? 5 : 2) * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".projects-view-list-container .".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            if (contentWidth_1 !== nextProps.contentWidth) {
                nextProps.setContentWidth(contentWidth_1);
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isMobile !== nextProps.isMobile ||
            this.props.selected !== nextProps.selected ||
            this.props.projectListStatus !== nextProps.projectListStatus ||
            this.props.items !== nextProps.items ||
            this.props.offset !== nextProps.offset ||
            this.props.limit !== nextProps.limit ||
            this.props.contentWidth !== nextProps.contentWidth) {
            return true;
        }
        return false;
    }
}));
function getHeaderColumn(props, name, identifier) {
    var order = props.orderByOptions.orderBy === identifier &&
        props.orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic projects-list-row-column extends', dataKey) },
        React.createElement("div", { onClick: function () { return props.sortBy(identifier, order); } }, (0, translation_1.getLocalization)("userFront/projectsTab/columns/".concat(name))),
        React.createElement(SortButton, { className: "sort d-none d-desktop-table-cell", order: props.orderByOptions.orderBy === identifier
                ? props.orderByOptions.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () { return props.sortBy(identifier, order); } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames('filter', props.filterOptions && props.filterOptions[identifier] ? 'active' : ''), columnIdentifier: identifier, textInputValue: props.filterOptions && props.filterOptions[identifier]
                ? props.filterOptions[identifier] || ''
                : '', inputType: 'text', setColumnFilterString: function (field, value) {
                return props.setColumnFilter(field, value);
            }, clearColumnFilter: function (field) { return props.setColumnFilter(field, undefined); } })));
}
// Helper function memoizes props to avoid unnecessary re-renders of Row component.
var _createRowData = function (isMobile, projects, selected, selectedLanguage, showAdminTools, toggleSelection, toggleBookmark, downloadProject) { return ({
    isMobile: isMobile,
    projects: projects,
    selected: selected,
    selectedLanguage: selectedLanguage,
    showAdminTools: showAdminTools,
    toggleSelection: toggleSelection,
    toggleBookmark: toggleBookmark,
    downloadProject: downloadProject
}); };
var CreateRowDataExtractable = Types.extractReturnType(_createRowData);
var createRowData = memoize(_createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, projects = data.projects;
    var props = data;
    var row = projects[index];
    return (React.createElement("div", { className: classNames('row'), style: style },
        props.showAdminTools && (React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                    e.stopPropagation();
                    props.toggleSelection(row);
                }, className: props.selected.findIndex(function (x) { return x.id === row.id; }) > -1
                    ? 'selected'
                    : null }))),
        React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-bookmark', className: row.bookmarked ? 'bookmarked' : '', onClick: function (e) {
                    e.stopPropagation();
                    props.toggleBookmark(row, !row.bookmarked);
                } })),
        props.showAdminTools && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row__column narrow" },
                React.createElement(sok_ui_1.Tooltip, { tipPosition: 'right', content: React.createElement("span", null, (0, translation_1.getLocalization)("admin/projectsTab/toolTips/editProject")) },
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/admin/projects/").concat(row.id), className: "row__column narrow" },
                        React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-pencil', className: 'black' })))),
            React.createElement("div", { className: "row__column narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("admin/projectsTab/toolTips/downloadProject")) },
                    React.createElement(Icon_1.Icon, { className: 'sok-icon-download-cloud', onClick: function () { return props.downloadProject(row); } }))))),
        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/").concat(row.id), className: classNames("row__column dynamic expand __name"), "data-key": "__name", "data-length": row.name.length },
            React.createElement("div", null, row.name)),
        props.showAdminTools && (React.createElement("div", { className: 'row__column narrow' }, row.hasNotes && (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("userFront/projectsTab/toolTips/notes")) },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-exclamation-square' }))))),
        props.showAdminTools && (React.createElement("div", { className: 'row__column narrow' }, row.type === 'DRAFT_PROJECT' && (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("userFront/projectsTab/toolTips/projectIsDraft")) },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-exclamation-triangle' }))))),
        getColumn('customerName', row.customerName || '-'),
        getColumn('projectId', (row.projectId || '-').toString()),
        getColumn('description', row.description || '-'),
        getColumn('projectStatus', row.projectStatus
            ? (0, translation_1.getLocalization)("projectStatus/".concat(row.projectStatus.name))
            : '-'),
        getColumn('projectType', row.projectType
            ? (0, translation_1.getLocalization)("projectType/".concat(row.projectType.name))
            : '-')));
});
exports.ListContainer = enhance(function (props) {
    var itemData = createRowData(props.isMobile, props.items, props.selected, props.selectedLanguage, props.showAdminTools, props.toggleSelection, props.toggleBookmark, props.downloadProjectFilesZip(props.token));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'projects-view-list-container' },
            React.createElement("div", { className: 'sok-list-content projects-view-list ' +
                    props.projectListStatus.toLowerCase() },
                props.projectListStatus === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.onFetchProjects }))),
                props.projectListStatus === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.projectListStatus === 'FETCHED' && (React.createElement(React.Fragment, null, props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemData: itemData, itemCount: props.items.length, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, placeholder: React.createElement(NotFoundPlaceHolder, __assign({}, props)), header: React.createElement(Header, { isMobile: props.isMobile, width: props.contentWidth, filterOptions: props.filterOptions, orderByOptions: props.orderByOptions, showAdminTools: props.showAdminTools, sortBy: props.sortBy, setColumnFilter: props.setColumnFilter }) }, ListRow));
                })))))),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.limit, total: props.totalItems, limitOptions: props.itemsPerPage, offset: props.offset, updatePageState: props.onPaginationChange })));
});
